import React from "react";

// PO1-3178: selo da FONTE da proposta (API da transportadora x tabela do sistema).
//
// Nasceu duplicado dentro do Step3Transportadora da Nova Cotação Manual, a única
// tela que exibia a fonte. Com a Cotação em Lote e o Editar Cotação passando a
// exibir também, virou componente — três cópias do mesmo estilo inline é como se
// perde a consistência entre telas que mostram o mesmo dado.
//
// Valores possíveis de `fonte` vêm do backend: 'api' ou 'tabela'
// (FreteService.js:549 e CotacaoConectorService.js:188). PO1-3200: 'spot' nasce
// no frontend, no "+ Frete Spot" (valor negociado por fora, sem simulação).
// PO1-3086 (épico PO1-3076): 'leilao' nasce no backend_hub na adjudicação do
// Leilão Reverso de Frete (um lance vigente por transportadora).
const FONTES = {
  api: { rotulo: "API", titulo: "Cotação via API da transportadora", cor: "#1d8cf8" },
  spot: { rotulo: "Spot", titulo: "Frete spot: valor negociado com a transportadora", cor: "#ff8d72" },
  leilao: { rotulo: "Leilão", titulo: "Lance recebido no leilão reverso de frete", cor: "#00bf9a" },
  tabela: { rotulo: "Tabela", titulo: "Tabela de frete do sistema", cor: "#9a9a9a" },
};

export default function FonteBadge({ fonte, style }) {
  const cfg = FONTES[fonte] || FONTES.tabela;
  return (
    <span
      title={cfg.titulo}
      style={{
        marginLeft: 6,
        fontSize: "0.62rem",
        textTransform: "uppercase",
        letterSpacing: "0.03em",
        padding: "1px 5px",
        borderRadius: 3,
        border: "1px solid rgba(255,255,255,0.18)",
        color: cfg.cor,
        whiteSpace: "nowrap",
        ...style,
      }}
    >
      {cfg.rotulo}
    </span>
  );
}
